import { Component } from '@angular/core';
import { FormDipendenteComponent } from 'src/app/shared/components/form/form-dipendente/form-dipendente.component';

@Component({
  selector: 'app-dipendenti-new',
  templateUrl: './dipendenti-new.component.html',
  styleUrls: ['./dipendenti-new.component.scss'],
  imports: [FormDipendenteComponent],
  standalone: true,
})
export class DipendentiNewComponent {

}

